export const FETCH_ALLMESSAGE_REQUEST = 'FETCH_ALLMESSAGE_REQUEST'
export const FETCH_ALLMESSAGE_SUCCESS = 'FETCH_ALLMESSAGE_SUCCESS'
export const FETCH_ALLMESSAGE_FALIURE = 'FETCH_ALLMESSAGE_FALIURE'
